import { BlogArticle } from '../types';

// DSE 倒數 30 日溫書計劃 → CTA: /module/exam
const article: BlogArticle = {
  slug: 'dse-30-day-countdown-plan',
  date: '2026-09-21',
  readingMinutes: 5,
  tags: ['DSE', '溫書計劃', '考試攻略'],

  locales: {
    zhHant: {
      title: 'DSE 倒數 30 日：最後衝刺溫書計劃',
      excerpt: '仲有一個月就考 DSE？呢個三階段溫書計劃，幫你將最後 30 日用得一分唔嘥。',
      keywords: 'DSE, DSE溫書, 考試計劃, 倒數30日, past paper',
      contentHtml: `
        <p>距離 DSE 仲有 30 日，唔少同學會開始慌：書溫唔晒、卷做唔完。其實最後一個月最緊要嘅唔係「溫幾多」，而係「點樣溫」。以下三階段計劃，幫你有系統咁用好每一日。</p>

        <h2>第 1–10 日：掃盲期</h2>
        <p>目標係<strong>搵出弱項</strong>，而唔係由頭到尾再溫一次。</p>
        <ul>
          <li>列出每科最弱嘅 3 個課題</li>
          <li>重溫筆記同錯題簿，集中攻呢啲位</li>
          <li>每個課題做少量題目驗證自己真係明</li>
        </ul>

        <h2>第 11–20 日：操練期</h2>
        <p>開始大量做 past paper，<strong>一定要計時</strong>。做卷唔係目的，檢討先係：</p>
        <ol>
          <li>計時完成一份卷</li>
          <li>即刻對答案，將錯題分類（唔識 / 粗心 / 時間唔夠）</li>
          <li>針對錯因返去溫相關課題</li>
        </ol>

        <div class="tip-box">
          <strong>💡 貼士：</strong>「唔識」嘅錯題要即日處理；「粗心」嘅錯題記低規律（例如成日計錯數），考試時特別留意。
        </div>

        <h2>第 21–30 日：模擬期</h2>
        <p>進入全真模擬狀態：按考試時間表做卷，訓練生理時鐘同答題節奏。最後 3 日唔好再學新嘢，只重溫錯題同公式，保持狀態。</p>

        <h2>三階段一覽</h2>
        <table>
          <thead>
            <tr><th>階段</th><th>目標</th><th>每日重點</th></tr>
          </thead>
          <tbody>
            <tr><td>第 1–10 日</td><td>掃盲</td><td>弱項課題 + 錯題重溫</td></tr>
            <tr><td>第 11–20 日</td><td>操練</td><td>計時 past paper + 檢討</td></tr>
            <tr><td>第 21–30 日</td><td>模擬</td><td>全真模擬 + 調整狀態</td></tr>
          </tbody>
        </table>

        <p>想喺操練期有多啲題目做？用 AI 按你嘅弱項生成模擬試卷，仲附答案同評分：</p>
        <p><a class="blog-cta-button" href="/module/exam">🎓 免費生成 DSE 模擬試卷 →</a></p>

        <blockquote>最後 30 日，比嘅唔係努力，係策略。加油！💪</blockquote>
      `,
    },

    zhHans: {
      title: 'DSE 倒数 30 天：最后冲刺复习计划',
      excerpt: '还有一个月就考 DSE？这个三阶段复习计划，帮你把最后 30 天用得一分不浪费。',
      keywords: 'DSE, DSE复习, 考试计划, 倒数30天, past paper',
      contentHtml: `
        <p>距离 DSE 还有 30 天，不少同学开始慌：书复习不完、卷做不完。其实最后一个月最重要的不是「复习多少」，而是「怎么复习」。以下三阶段计划，帮你系统地用好每一天。</p>

        <h2>第 1–10 天：扫盲期</h2>
        <p>目标是<strong>找出弱项</strong>，而不是从头到尾再复习一遍。</p>
        <ul>
          <li>列出每科最弱的 3 个课题</li>
          <li>重温笔记和错题本，集中攻这些位</li>
          <li>每个课题做少量题目验证自己真的懂</li>
        </ul>

        <h2>第 11–20 天：操练期</h2>
        <p>开始大量做 past paper，<strong>一定要计时</strong>。做卷不是目的，检讨才是：</p>
        <ol>
          <li>计时完成一份卷</li>
          <li>立刻对答案，把错题分类（不会 / 粗心 / 时间不够）</li>
          <li>针对错因回去复习相关课题</li>
        </ol>

        <div class="tip-box">
          <strong>💡 提示：</strong>「不会」的错题要当天处理；「粗心」的错题记下规律（例如经常算错数），考试时特别留意。
        </div>

        <h2>第 21–30 天：模拟期</h2>
        <p>进入全真模拟状态：按考试时间表做卷，训练生物钟和答题节奏。最后 3 天不要再学新东西，只重温错题和公式，保持状态。</p>

        <h2>三阶段一览</h2>
        <table>
          <thead>
            <tr><th>阶段</th><th>目标</th><th>每日重点</th></tr>
          </thead>
          <tbody>
            <tr><td>第 1–10 天</td><td>扫盲</td><td>弱项课题 + 错题重温</td></tr>
            <tr><td>第 11–20 天</td><td>操练</td><td>计时 past paper + 检讨</td></tr>
            <tr><td>第 21–30 天</td><td>模拟</td><td>全真模拟 + 调整状态</td></tr>
          </tbody>
        </table>

        <p>想在操练期有更多题目做？用 AI 按你的弱项生成模拟试卷，还附答案和评分：</p>
        <p><a class="blog-cta-button" href="/module/exam">🎓 免费生成 DSE 模拟试卷 →</a></p>

        <blockquote>最后 30 天，比的不是努力，是策略。加油！💪</blockquote>
      `,
    },

    en: {
      title: 'DSE 30-Day Countdown: Your Final Sprint Study Plan',
      excerpt: 'One month to the DSE? This three-phase plan helps you squeeze the most out of every single day.',
      keywords: 'DSE, study plan, exam preparation, past papers, 30 day countdown',
      contentHtml: `
        <p>Thirty days to the DSE and feeling behind? The final month isn't about how much you study — it's about how you study. This three-phase plan structures every day so nothing goes to waste.</p>

        <h2>Days 1–10: Gap-finding phase</h2>
        <p>The goal is to <strong>find your weak spots</strong>, not to re-read everything from the start.</p>
        <ul>
          <li>List your 3 weakest topics per subject</li>
          <li>Review notes and your mistake log, focusing on those topics</li>
          <li>Do a few questions per topic to confirm you truly understand</li>
        </ul>

        <h2>Days 11–20: Drilling phase</h2>
        <p>Start doing past papers in volume — <strong>always timed</strong>. Finishing a paper isn't the goal; the review is:</p>
        <ol>
          <li>Complete a paper under timed conditions</li>
          <li>Mark it immediately and classify every mistake (don't know / careless / ran out of time)</li>
          <li>Go back and study the topics behind each mistake</li>
        </ol>

        <div class="tip-box">
          <strong>💡 Tip:</strong> Fix "don't know" mistakes the same day. For "careless" mistakes, look for patterns (e.g. always misreading the question) and flag them for exam day.
        </div>

        <h2>Days 21–30: Simulation phase</h2>
        <p>Switch to full exam simulation: sit papers at the real exam times to train your body clock and pacing. In the final 3 days, learn nothing new — review mistakes and formulas only, and protect your condition.</p>

        <h2>The plan at a glance</h2>
        <table>
          <thead>
            <tr><th>Phase</th><th>Goal</th><th>Daily focus</th></tr>
          </thead>
          <tbody>
            <tr><td>Days 1–10</td><td>Find gaps</td><td>Weak topics + mistake review</td></tr>
            <tr><td>Days 11–20</td><td>Drill</td><td>Timed past papers + review</td></tr>
            <tr><td>Days 21–30</td><td>Simulate</td><td>Full mocks + condition</td></tr>
          </tbody>
        </table>

        <p>Need more practice questions for the drilling phase? Generate mock papers tailored to your weak topics, with answer keys and marking:</p>
        <p><a class="blog-cta-button" href="/module/exam">🎓 Generate a free DSE mock paper →</a></p>

        <blockquote>The last 30 days aren't about effort — they're about strategy. Good luck! 💪</blockquote>
      `,
    },
  },
};

export default article;
